const VIEWPORT_MARGIN = 8
const ANCHOR_GAP = 6
const MAX_HEIGHT_VIEWPORT_RATIO = 0.9

interface AnchorRect {
  left: number
  right: number
  bottom: number
}

// Fixed-position coordinates for a dropdown anchored to an element, shifted
// so it stays inside the viewport. The dropdown opens below the anchor when
// its content fits there; otherwise it is raised just enough to fit, capped
// at 90% of the viewport height (scrolling internally via maxHeight).
export const computeDropdownPosition = (
  anchorRect: AnchorRect,
  dropdownWidth: number,
  contentHeight: number,
  align: "left" | "right",
  viewportWidth: number,
  viewportHeight: number,
) => {
  let left = align === "right" ? anchorRect.right - dropdownWidth : anchorRect.left
  left = Math.min(left, viewportWidth - VIEWPORT_MARGIN - dropdownWidth)
  left = Math.max(left, VIEWPORT_MARGIN)

  const height = Math.min(contentHeight, viewportHeight * MAX_HEIGHT_VIEWPORT_RATIO)
  let top = anchorRect.bottom + ANCHOR_GAP
  if (top + height > viewportHeight - VIEWPORT_MARGIN) {
    top = Math.max(VIEWPORT_MARGIN, viewportHeight - VIEWPORT_MARGIN - height)
  }
  const maxHeight = Math.min(height, viewportHeight - top - VIEWPORT_MARGIN)

  return { left, top, maxHeight }
}
